import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ICompetition } from '@models/competition';
import dayjs from 'dayjs';

@Injectable({
  providedIn: 'root',
})
export class CompetitionApiService {
  private httpClient = inject(HttpClient);

  createCompetition(start_date: string, end_date: string): Observable<ICompetition> {
    return this.httpClient
      .post<ICompetition>(`${environment.apiUrlV2}/company/competitions`, {
        name: '',
        start_date,
        end_date,
        timezone: dayjs.tz.guess(),
      })
      .pipe(map(c => ({ ...c, ranking: [] })));
  }

  getCompetitions(): Observable<ICompetition[]> {
    return this.httpClient
      .get<{
        items: ICompetition[];
      }>(`${environment.apiUrlV2}/company/competition/leaderboard/competitions/ranking`)
      .pipe(map(c => c.items));
  }

  sendEmails(id: string): Observable<void> {
    return this.httpClient.post<void>(
      `${environment.apiUrlV2}/company/competition/${id}/mailing`,
      {}
    );
  }
}
